export default "__VITE_ASSET__BOArDKQR__"